var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"flash-container mt-3"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isRendered),expression:"isRendered"}],ref:"container",domProps:{"innerHTML":_vm._s(_vm.noteHtml)}})])}
var staticRenderFns = []

export { render, staticRenderFns }